
<template>
  <el-popover
    placement="left-start"
    width="580"
    trigger="manual"
    popper-class="country-popper"
    v-model="visible"
    @hide="close"
  >
    <div>
      <div class="header">
        <el-input v-model.trim="searchVal" />
        <el-button type="primary" size="mini" @click="searchBtn"
          >查询</el-button
        >
        <i class="el-icon-close" @click="visible = false"></i>
      </div>
      <div class="content">
        <span
          v-for="(item, index) in options"
          :key="index"
          @click="addCountry(item)"
          >{{ item.name }}</span
        >
      </div>
    </div>
    <el-button
      slot="reference"
      class="more-btn"
      size="mini"
      @click="visible = !visible"
      >{{ searchResult || '更多'
      }}<i class="el-icon-arrow-down el-icon--right"></i
    ></el-button>
  </el-popover>
</template>
<script>
export default {
  props: {},
  data() {
    return {
      visible: false,
      searchVal: '',
      searchResult: '',
      options: [],
      allCountry: [],
    };
  },
  mounted() {
    this.getAllCountry();
  },
  methods: {
    getAllCountry() {
      this.$http.setting
        .getCountry()
        .then(result => {
          this.allCountry = result.data;
          this.options = result.data;
        })
        .catch(err => {
          this.$message.error(err.msg);
        });
    },
    searchBtn() {
      this.options = this.allCountry.filter(item => {
        return (
          item.name.toLowerCase().indexOf(this.searchVal.toLowerCase()) > -1
        );
      });
    },
    addCountry({ name }) {
      this.searchResult = name;
      this.$emit('country-change', name);
      this.visible = false;
    },
    close() {
      this.searchVal = '';
      this.searchBtn();
    },
  },
};
</script>

<style lang="less">
.country-popper {
  .content {
    height: 400px;
    overflow: auto;
    position: relative;
  }
  span {
    display: inline-block;
    width: 100px;
    height: 20px;
    line-height: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin: 5px;
    &:hover {
      color: #AB0033;
      text-decoration: underline;
      cursor: pointer;
    }
  }
  .header {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    .el-input--mini,
    .el-input__inner {
      width: 200px;
    }
    .el-button {
      padding: 0;
      margin: 0 10px;
      span {
        width: 50px;
        height: 16px;
      }
    }
    .el-icon-close {
      position: absolute;
      right: 15px;
      top: 15px;
      font-size: 20px;
      cursor: pointer;
    }
  }
}
</style>